import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DELETE_PROJECT_GROUP_MUTATION } from "../../../../graphql/mutations";

const DeleteProjectGroupModal = ({ show, env, handleEnvChange, projectGroup, tenantName, tenantId, handleClose }) => {
  const navigate = useNavigate();

  const [deleteProjectGroup, { loading: mutationLoading }] = useMutation(DELETE_PROJECT_GROUP_MUTATION);

  const handleDelete = async () => {
    try {
      const { data } = await deleteProjectGroup({
        variables: {
          projectGroupId: projectGroup.id
        }
      });

      if (data?.deleteProjectGroup) {
        handleClose();
        setTimeout(() => {
          toast.success(`Project group deleted successfully.`);
          navigate("/projects");
          handleEnvChange(env, tenantId, tenantName);
        }, 200);
      }
    } catch (error) {
      handleClose();
      setTimeout(() => {
        toast.error("Failed to delete project group.");
        console.error("Delete error:", error);
      }, 200);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="d-flex justify-content-center">
        <Modal.Title className="w-100 text-center">Delete Project Group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          Are you sure you want to delete the project group <strong>{projectGroup?.name}</strong>?
        </p>
        <p className="text-center text-danger">This action cannot be undone and may affect associated data.</p>
        <div className="d-flex justify-content-center mt-4">
          <Button variant="primary" onClick={handleClose} className="me-2" disabled={mutationLoading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete} disabled={mutationLoading}>
            {mutationLoading ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { DeleteProjectGroupModal };
